import { render, staticRenderFns } from "./visualizarSolicitudesMateriales.vue?vue&type=template&id=4b272acc&scoped=true&"
import script from "./visualizarSolicitudesMateriales.vue?vue&type=script&lang=js&"
export * from "./visualizarSolicitudesMateriales.vue?vue&type=script&lang=js&"
import style0 from "./visualizarSolicitudesMateriales.vue?vue&type=style&index=0&id=4b272acc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b272acc",
  null
  
)

export default component.exports